import { ClientEnvironment, FormatFileSizePipe } from '@thehubz/client/core';
import { AssetFileFormat } from '@thehubz/client/data-access-api';
import { AnyType } from '@thehubz/shared/model';

export function filterFormats(env: ClientEnvironment) {
  return (format: AssetFileFormat) => {
    if (format.fileNameRef.startsWith('gen-thumbnail')) {
      return false;
    }
    if (env.assetDownload?.excludeFormat?.includes(format.fileNameRef as AnyType)) {
      return false;
    }
    return true;
  };
}

export function sortFormats(env: ClientEnvironment) {
  return (a: AssetFileFormat, b: AssetFileFormat) => {
    if (a.fileNameRef === 'main') return -1;
    if (b.fileNameRef === 'main') return 1;
    if (env.assetDownload?.sortFormatsBy === 'size') {
      return b.size - a.size;
    } else if (env.assetDownload?.sortFormatsBy === 'medium') {
      // compare by assetMedium
      if (a.assetMedium && b.assetMedium) {
        return a.assetMedium.localeCompare(b.assetMedium);
      } else {
        return a.fileNameRef.localeCompare(b.fileNameRef);
      }
    }
    return a.fileNameRef.localeCompare(b.fileNameRef);
  };
}

export function setFormatName(formatFileSize?: FormatFileSizePipe) {
  return (format: AssetFileFormat) => {
    switch (true) {
      case format.fileNameRef === 'main':
        format.name = 'Original';
        break;
      case format.fileNameRef === 'gen-thumbnail':
        format.name = $localize`Thumbnail file`;
        break;
      case format.fileNameRef === 'gen-preview':
        format.name = $localize`Preview file`;
        break;
      case format.fileNameRef === 'gen-preview-xl':
        format.name = $localize`Preview file large`;
        break;
      case format.fileNameRef.startsWith('gen-midres'):
        if (format.ext === 'mp4') {
          format.name = 'Video medium';
        } else {
          format.name = $localize`Image medium`;
        }
        break;
      case format.fileNameRef.startsWith('gen-lowres'):
        if (format.ext === 'mp4') {
          format.name = 'Video small';
        } else {
          format.name = $localize`Image small`;
        }
        break;
      default:
        format.name = `${format.name} (${format.fileNameRef.charAt(0).toUpperCase() + format.fileNameRef.slice(1)})`;
    }
    if (format.size && formatFileSize) {
      format.name += ` (${formatFileSize.transform(format.size)})`;
    }
    return format;
  };
}
